import { useEffect } from 'react';
import { supabase } from "@/integrations/supabase/client";

const Sitemap = () => {
  useEffect(() => {
    const fetchSitemap = async () => {
      try {
        const { data, error } = await supabase.functions.invoke('sitemap');
        
        if (error) {
          console.error('Error fetching sitemap:', error);
          return;
        }

        // Set the content type to XML
        const xmlContent = new Blob([data], { type: 'application/xml' });
        const xmlUrl = URL.createObjectURL(xmlContent);
        
        // Redirect to the XML content
        window.location.href = xmlUrl;
      } catch (error) {
        console.error('Error:', error);
      }
    };

    fetchSitemap();
  }, []);

  return null;
};

export default Sitemap;